import { FINANCIAL_PRODUCT_C } from './../../../@core/constants/requests.constants';
import { element } from 'protractor';
import { map } from 'rxjs/operators';
import { from } from 'rxjs';
import { TransformRemoveFormatPipe } from './../../pipes/transform-remove-format.pipe';
import { ActionAgentExcelData, AgentActionPlanSearchDTO } from './../../../control-panel/models/control-panel.model';
import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import { Row, Workbook, Worksheet, Cell } from 'exceljs';
import { TariffSheet } from '@app/tariffs/model/tariffs-model';
import { TranslateService } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';
import { OperationDetailRequestDTO } from '@app/control-panel/models/control-panel.model';
import { MacroReportResponseAuxDTO } from '@app/activity/model/activity-model';
import { CustomValidatorsService } from '@app/@shared/custom-validators/custom-validators.service';
import {
  REGEX_FORMAT_NUMBER,
  REGEX_WITHOUT_DOT,
  REGEX_NUMBER_WITHOUT_HUNDREDS,
  REGEX_ANY_LETTER,
  REGEX_VALID_DATE,
  LOCALE_DE,
} from '@app/@core/constants/common.constants';
import moment from 'moment';
import { MonthlyResult } from '@app/activity/model/activity-model';
import { UserDivisions } from '@app/@core/constants/user-credentials.constants';
import { FINANCIAL_PRODUCT_AUTO } from '@app/@core/constants/requests.constants';
import { excelDataPenalty } from './excel-models';

let excelPaymentReportData = [
  'paymentDate', //fecha pago
  'lot',
  'numOperation',
  'contractId', //referencia¿?
  'establishment',
  'company',
  'cifBeneficiary', //NIF/CIF beneficiario
  'recipient', //beneficiario / destinatario
  'netAmount',
  'amount',
  'financialExpenses', //importe
  'titleholder', //titular
  'description', //descripcion
  'reference', //campo referencia
  'reference2',
  'idOwnStoreAgreement', //id_tienda
  'operative',
];

const logo =
  'data:image/png;base64,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';

@Injectable({
  providedIn: 'root',
})
export class ExcelService {
  constructor(
    private translateService: TranslateService,
    private datePipe: DatePipe,
    readonly removeFormat: TransformRemoveFormatPipe
  ) {}

  getTitleDashboardReport(): string {
    return this.translateService.instant('excel.dashboard.title');
  }

  getTitleOperationValidationList(): string {
    return this.translateService.instant('operationValidation.operationList');
  }

  getNameExcelDate(): string {
    return this.translateService.instant('excel.date');
  }

  getNameExcelOffice(): string {
    return this.translateService.instant('excel.office');
  }

  getPaymentReportPag(): string {
    return this.translateService.instant('paymentReports.table.page');
  }

  getNameExcelDivision(): string {
    return this.translateService.instant('excel.division');
  }

  getPaymentReportTableDate(): string {
    return this.translateService.instant('paymentReports.table.date');
  }

  getNameExcelPeriod(): string {
    return this.translateService.instant('excel.period');
  }

  headerExcel(title: any, header: any, workbook: Workbook, worksheet: Worksheet, dateFormat?: string) {
    //Add Row and formatting
    if (title === this.getTitleOperationValidationList()) {
      worksheet.mergeCells('D1', 'I5');
      let titleRow = worksheet.getCell('D1');
      titleRow.value = this.getTitleDashboardReport();
      titleRow.font = {
        name: 'Calibri',
        size: 30,
        bold: true,
        color: { argb: '1E90FF' },
      };
      (titleRow.alignment = { vertical: 'middle', horizontal: 'center' }),
        // Date and page
        (worksheet.getCell('H7').value = this.getNameExcelDate());
      worksheet.getCell('H7').style = { alignment: { vertical: 'middle', horizontal: 'right' }, font: { bold: true } };
      let d = new Date();
      let month = d.getMonth() + 1;
      let date = d.getDate() + '/' + (month < 10 ? '0' + month : '' + month) + '/' + d.getFullYear();
      let dateCell = worksheet.getCell('I7');
      dateCell.value = date;
      dateCell.style = { alignment: { vertical: 'middle', horizontal: 'left' } };

      worksheet.mergeCells('D7:G8');
      worksheet.getCell('D7').value = title;
      worksheet.getCell('D7').style = {
        alignment: { vertical: 'middle', horizontal: 'center' },
        font: { name: 'Calibri', size: 18, bold: true, underline: 'single', color: { argb: '828282' } },
      };

      worksheet.addRow([]);
    } else {
      //Add Row and formatting
      worksheet.mergeCells('D1', 'G5');
      let titleRow = worksheet.getCell('D1');
      titleRow.value = title;
      titleRow.font = {
        name: 'Calibri',
        size: 16,
        underline: 'single',
        bold: true,
        color: { argb: '969696' },
      };
      titleRow.alignment = { vertical: 'middle', horizontal: 'center' };

      // Date
      let date: string = this.datePipe.transform(new Date(), dateFormat ? dateFormat : 'dd/MM/yyyy');
      if (date) {
        if (date.includes('a. m.')) date = date?.charAt(0).toUpperCase() + date.slice(1).split('a. m.')[0] + 'AM';
        else if (date.includes('p. m.')) date = date?.charAt(0).toUpperCase() + date.slice(1).split('p. m.')[0] + 'PM';
      }
      let dateCell = worksheet.getCell('H3');
      dateCell.value = date;
      dateCell.font = {
        name: 'Calibri',
        size: 12,
        bold: true,
      };
      dateCell.alignment = { vertical: 'middle', horizontal: 'center' };
    }

    //Add Image
    let myLogoImage = workbook.addImage({
      base64: logo,
      extension: 'png',
    });
    worksheet.mergeCells('A1:C5');
    worksheet.addImage(myLogoImage, 'A1:C5');

    worksheet.addRow([]);

    console.log(header);

    //Adding Header Row
    let headerRow = worksheet.addRow(header);
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '969696' },
        bgColor: { argb: '' },
      };
      cell.font = {
        bold: true,
        color: { argb: 'FFFFFF' },
        size: 12,
      };
    });

    if (worksheet.name !== 'Consulta usuarios') {
      worksheet.addRow([]);
    }
  }

  generateExcel(title: any, workbook: Workbook) {
    //Generate & Save Excel File
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      FileSaver.saveAs(blob, title + '.xlsx');
    });
  }

  exportExcelUsersSearch(excelData: any) {
    //Title, Header & Data
    const title = this.translateService.instant('finduser.pdf.header');
    const header = excelData.headers;
    const data = excelData.data;
    const worksheetTitle = this.translateService.instant('finduser.pdf.title');
    const date = this.datePipe.transform(new Date(), 'ddMMyyyy');
    const filename = this.translateService.instant('finduser.pdf.filename', { date: date });
    //Create a workbook with a worksheet
    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet(worksheetTitle);

    this.headerExcel(title, header, workbook, worksheet);

    let bodyRows: any;
    let contRow = 0;

    data.map(Object.values).forEach((d: any) => {
      bodyRows = worksheet.addRow(d);
      bodyRows.eachCell((cell: any, number: any) => {
        cell.border = {
          right: { style: 'thick' },
        };
        if (contRow === 0) {
          cell.border = {
            top: { style: 'thick' },
            right: { style: 'thick' },
          };
        }
      });
      contRow++;
    });

    worksheet.addRow([]);

    worksheet.columns.forEach(function (column, i) {
      column.width = i === 0 || i === 3 || i === 4 ? 21 : i === 7 ? 15 : 10;
    });

    this.generateExcel(title, workbook);
  }

  exportExcel(excelData: any, name?: string) {
    //Title, Header & Data
    const fileName = excelData.fileName;
    const title = name ? name : 'Listado de las últimas operaciones';
    const state = excelData.state;
    const header = excelData.headers;
    const data = excelData.data;

    for (let i = 0; i < data.length; i++) {
      for (let j = 0; j < data[i].length; j++) {
        data[i][j] = this.checkNumbersFormat(data[i][j]);
      }
    }

    //Create a workbook with a worksheet
    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet(name ? name : 'Últimas operaciones');

    this.headerExcel(title, header, workbook, worksheet);

    worksheet.mergeCells('A8:B8');
    if (state) {
      worksheet.getCell('A8').value = this.translateService.instant(state)?.toUpperCase();
    }
    worksheet.getCell('A8').font = {
      name: 'Calibri',
      size: 12,
      bold: true,
    };

    let bodyRows: Row;
    let contRow = 0;

    let dataBodyExcel;
    const isArray = Array.isArray(data);
    dataBodyExcel = isArray ? data : data.map(Object.values);
    dataBodyExcel.forEach((d: any) => {
      bodyRows = worksheet.addRow(d);
      bodyRows.eachCell({ includeEmpty: true }, (cell: any, index: number) => {
        cell.border = {
          right: { style: 'thick' },
        };
        if (contRow === 0) {
          cell.border = {
            top: { style: 'thick' },
            right: { style: 'thick' },
          };
        }
      });
      contRow++;
    });

    worksheet.addRow([]);

    worksheet.columns.forEach(function (column, i) {
      column.width = i === 0 || i === 1 || i === 2 || i === 3 || i === 4 || i === 10 ? 21 : i === 7 ? 15 : 10;
    });

    this.generateExcel(fileName, workbook);
  }

  exportExcelAll(excelDataAll: any, name?: string) {
    //Title, Header & Data
    const fileName = excelDataAll?.fileName;
    const title = name ? name : 'Listado de las últimas operaciones';
    const header = excelDataAll.headers;
    const data = excelDataAll.data;
    let cont = name === this.translateService.instant('operationValidation.operationList') ? 12 : 8;

    //Create a workbook with a worksheet
    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet(this.translateService.instant('operationValidation.excel.tagName'));

    this.headerExcel(title, header, workbook, worksheet);

    if (title === this.getTitleOperationValidationList()) {
      worksheet.getCell('A7').value =
        this.translateService.instant('excel.extern') +
        (excelDataAll.commercialExt ? excelDataAll.commercialExt : this.translateService.instant('select.option.all'));
      worksheet.getCell('A8').value =
        this.getNameExcelOffice() +
        (excelDataAll.oficina ? excelDataAll.oficina : this.translateService.instant('select.option.allFem'));
    }

    data.forEach((item: any) => {
      //Blank Row
      worksheet.getCell('A' + cont).value =
        name === this.getTitleOperationValidationList()
          ? item.statusDesc
          : this.translateService.instant(item.state)?.toUpperCase();
      worksheet.getCell('A' + cont).font = {
        name: 'Calibri',
        size: 12,
        bold: true,
      };

      // Adding Data with Conditional Formatting
      let bodyRows: any;
      let contRow = 0;

      for (let i = 0; i < item.data.length; i++) {
        let keys = Object.keys(item.data[i]);
        for (let j = 0; j < keys.length; j++) {
          item.data[i][keys[j]] = this.checkNumbersFormat(item.data[i][keys[j]]);
        }
      }
      item.data.map(Object.values).forEach((d: any) => {
        bodyRows = worksheet.addRow(d);
        bodyRows.eachCell((cell: any, number: any) => {
          cell.border = {
            right: { style: 'thick' },
          };
          if (contRow === 0) {
            cell.border = {
              top: { style: 'thick' },
              right: { style: 'thick' },
            };
          }
        });
      });

      cont = cont + (name === this.getTitleOperationValidationList() ? item.data.length + 1 : 8);
    });

    worksheet.addRow([]);

    worksheet.columns.forEach(function (column, i) {
      if (i === 0 || i === 4) {
        column.width = 21;
      } else if (i === 1 || i === 6) {
        column.width = 20;
      } else if (i === 2) {
        column.width = 23;
      } else if (i === 3) {
        column.width = 35;
      } else if (i === 7) {
        column.width = 25;
      } else {
        column.width = 10;
      }
    });

    this.generateExcel(fileName, workbook);
  }

  exportExcelDetailOperations(excelData: any) {
    //Title, Header & Data
    const fileName = excelData?.fileName;
    const title = this.getTitleDashboardReport();
    //const state = excelData.state;
    const header = excelData.headers;
    const data: Array<any> = excelData.data;
    const division: string = excelData?.division;
    const dates: string[] = excelData?.date;

    const lastRowData: Array<any> = data[data.length - 1];
    data.splice(data.length - 1);

    //Create a workbook with a worksheet
    let workbook = new Workbook();
    const worksheet = workbook.addWorksheet(this.translateService.instant('excel.dashboard.sheet'), {
      pageSetup: { paperSize: 9, orientation: 'landscape', scale: 80 },
    });

    this.headerExcelDetailOperations(title, header, workbook, worksheet);

    worksheet.getCell('K7').value = this.getPaymentReportPag();
    worksheet.mergeCells('L7:N7');
    worksheet.getCell('L7').value = '1';

    worksheet.mergeCells('D6:G6');
    worksheet.getCell('D6').value = 'De ' + dates[0] + ' a ' + dates[1];

    worksheet.getCell('A8').value = `${this.getNameExcelDivision()} ${division}`;

    worksheet.mergeCells('A9:N9');
    worksheet.getCell('A9').value = this.translateService.instant('excel.inversionDO.list');
    worksheet.getCell('A9').style = {
      alignment: { horizontal: 'center' },
      font: {
        name: 'Calibri',
        size: 12,
        bold: true,
        underline: 'single',
        color: { argb: '828282' },
      },
    };

    worksheet.addRows(data);

    let dataLastRow: Array<any> = Array(14).fill('');
    dataLastRow[0] = 'TOTAL';
    dataLastRow[5] = lastRowData[0];
    dataLastRow[6] = 'Euros';
    dataLastRow[7] = lastRowData[1];
    dataLastRow[8] = 'Euros';

    let lastRow = worksheet.addRow(dataLastRow);
    lastRow.eachCell((cell: any) => {
      cell.border = {
        top: { style: 'thick' },
        bottom: { style: 'thick' },
      };
    });

    worksheet.addRow([]);

    worksheet.columns.forEach(function (column, i) {
      column.alignment = { vertical: 'middle', wrapText: true };
      column.width =
        i === 0 || i === 2 || i === 9
          ? 21
          : i === 1 || i === 4 || i === 5 || i === 6 || i === 7 || i === 10 || i === 12
          ? 10
          : 7;
    });

    this.generateExcel(fileName, workbook);
  }

  headerExcelDetailOperations(title: any, header: any, workbook: Workbook, worksheet: Worksheet) {
    //Add Row and formatting
    worksheet.mergeCells('H1', 'N5');
    let titleRow = worksheet.getCell('H1');
    titleRow.value = title;
    titleRow.font = {
      name: 'Calibri',
      size: 25,
      bold: true,
      color: { argb: '1E90FF' },
    };
    titleRow.alignment = { vertical: 'middle', horizontal: 'center' };

    // Date
    worksheet.getCell('K6').value = this.getPaymentReportTableDate();
    worksheet.mergeCells('L6:N6');
    let d = new Date();
    let month = d.getMonth() + 1;
    let date = d.getDate() + '/' + (month < 10 ? '0' + month : '' + month) + '/' + d.getFullYear();
    let dateCell = worksheet.getCell('L6');
    dateCell.value = date;

    dateCell.alignment = { vertical: 'middle', horizontal: 'center' };

    //Add Image
    let myLogoImage = workbook.addImage({
      base64: logo,
      extension: 'png',
    });
    worksheet.mergeCells('A1:C5');
    worksheet.addImage(myLogoImage, 'A1:C5');

    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);

    //Adding Header Row
    let headerRow = worksheet.addRow(header);
    headerRow.eachCell((cell, number) => {
      cell.style = {
        alignment: {
          shrinkToFit: true,
        },
        fill: {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '969696' },
          bgColor: { argb: '' },
        },
        font: {
          bold: true,
          color: { argb: 'FFFFFF' },
          size: 12,
        },
      };
    });
  }

  exportExcelInvestProduct(excelData: any, numColums: number) {
    //Title, Header & Data
    const title = this.getTitleDashboardReport();
    const fileName = excelData?.fileName;
    //const state = excelData.state;
    const header = excelData.headers;
    const data: Array<any> = excelData.data;
    const division: string = excelData?.division;
    const user: string = excelData?.user;
    const dates: string[] = excelData?.date;

    //Create a workbook with a worksheet
    let workbook = new Workbook();
    const worksheet = workbook.addWorksheet(this.translateService.instant('excel.dashboard.sheet'), {
      pageSetup: { paperSize: 9, orientation: 'landscape', fitToPage: true },
    });

    this.headerExcelDetailOperations(title, header, workbook, worksheet);

    worksheet.getCell('K7').value = this.getPaymentReportPag();
    worksheet.mergeCells('L7:N7');
    worksheet.getCell('L7').value = '1';

    worksheet.mergeCells('D6:G6');
    worksheet.getCell('D6').value = 'De ' + dates[0] + ' a ' + dates[1];

    worksheet.getCell('A7').value = user.split(':')[0]?.trim() + ':';
    worksheet.getCell('B7').value = user.split(':')[1]?.trim();
    worksheet.getCell('A8').value = this.getNameExcelDivision() + ' ';
    worksheet.getCell('B8').value = division;

    worksheet.mergeCells('A9:N9');
    worksheet.getCell('A9').value = this.translateService.instant('excel.inversionProduct.list');
    worksheet.getCell('A9').style = {
      alignment: { horizontal: 'center' },
      font: {
        name: 'Calibri',
        size: 12,
        bold: true,
        underline: 'single',
        color: { argb: '828282' },
      },
    };

    worksheet.addRows(data);

    //box for cells, columns =numColums, max 12
    let lettersList = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N'];
    for (let i = 0; i <= numColums; i++) {
      let letter = lettersList[i];

      worksheet.getCell(letter + '11').style = {
        border: { right: { style: 'thin' }, left: { style: 'thin' }, top: { style: 'thin' } },
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF' }, bgColor: { argb: '' } },
      };

      worksheet.getCell(letter + '12').style = {
        border: { right: { style: 'thin' }, left: { style: 'thin' } },
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF' }, bgColor: { argb: '' } },
      };

      worksheet.getCell(letter + '13').style = {
        border: { right: { style: 'thin' }, left: { style: 'thin' } },
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF' }, bgColor: { argb: '' } },
      };

      worksheet.getCell(letter + '14').style = {
        border: { right: { style: 'thin' }, left: { style: 'thin' } },
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF' }, bgColor: { argb: '' } },
      };

      worksheet.getCell(letter + '15').style = {
        border: { right: { style: 'thin' }, left: { style: 'thin' } },
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF' }, bgColor: { argb: '' } },
      };

      worksheet.getCell(letter + '16').style = {
        border: { right: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' } },
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF' }, bgColor: { argb: '' } },
      };

      worksheet.getCell(letter + '17').style = {
        border: { right: { style: 'thin' }, left: { style: 'thin' }, top: { style: 'thin' } },
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF' }, bgColor: { argb: '' } },
      };

      worksheet.getCell(letter + '18').style = {
        border: { right: { style: 'thin' }, left: { style: 'thin' } },
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF' }, bgColor: { argb: '' } },
      };

      worksheet.getCell(letter + '19').style = {
        border: { right: { style: 'thin' }, left: { style: 'thin' } },
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF' }, bgColor: { argb: '' } },
      };

      worksheet.getCell(letter + '20').style = {
        border: { right: { style: 'thin' }, left: { style: 'thin' } },
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF' }, bgColor: { argb: '' } },
      };

      worksheet.getCell(letter + '21').style = {
        border: { right: { style: 'thin' }, left: { style: 'thin' } },
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF' }, bgColor: { argb: '' } },
      };

      worksheet.getCell(letter + '22').style = {
        border: { right: { style: 'thin' }, left: { style: 'thin' } },
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF' }, bgColor: { argb: '' } },
      };

      worksheet.getCell(letter + '23').style = {
        border: { right: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' } },
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF' }, bgColor: { argb: '' } },
      };
    }

    worksheet.addRow([]);

    worksheet.columns.forEach(function (column, i) {
      column.alignment = { vertical: 'middle', wrapText: true };
      column.width = 14;
    });

    this.generateExcel(fileName, workbook);
  }

  headerExcelAgentStatistics(
    workbook: Workbook,
    division: string,
    product: string,
    typeArticle: string,
    dates: string[]
  ) {
    const numCurrentWorksheets = workbook.worksheets?.length;
    if (numCurrentWorksheets > 0) {
      let worksheet = workbook.getWorksheet(numCurrentWorksheets);

      //Add Image
      const myLogoImage = workbook.addImage({
        base64: logo,
        extension: 'png',
      });

      const imageCoords = 'A1:C5';
      worksheet.mergeCells(imageCoords);
      worksheet.addImage(myLogoImage, imageCoords);

      //TITLE
      const titleStartCoords = 'E2';
      worksheet.mergeCells(titleStartCoords, 'L5');
      const titleRow = worksheet.getCell(titleStartCoords);
      titleRow.value = this.getTitleDashboardReport();
      titleRow.style = {
        font: {
          name: 'Calibri',
          size: 30,
          bold: true,
          color: { argb: '1E90FF' },
        },
        alignment: { vertical: 'middle', horizontal: 'center' },
      };

      //Separator
      worksheet.getRow(6).height = 5;

      //Division
      const DIVISION_COLUMN = 1;
      const DIVISION_ROW = 8;
      const divisionLabelCell = worksheet.getCell(DIVISION_ROW, DIVISION_COLUMN);
      const divisionValueCell = worksheet.getCell(DIVISION_ROW, DIVISION_COLUMN + 1);

      divisionLabelCell.value = this.getNameExcelDivision();
      divisionValueCell.value = division;

      divisionLabelCell.alignment = {
        horizontal: 'right',
        vertical: 'middle',
      };
      divisionValueCell.alignment = {
        horizontal: 'left',
        vertical: 'middle',
      };

      //Subtitle
      const startTitleReportCoord = 'D8';
      worksheet.mergeCells(startTitleReportCoord, 'H8');

      const titleReportCell = worksheet.getCell(startTitleReportCoord);
      titleReportCell.value = this.translateService.instant('agentStatistics.subtitle');
      titleReportCell.style = {
        alignment: { horizontal: 'center' },
        font: {
          name: 'Calibri',
          size: 12,
          bold: true,
          underline: 'single',
          color: { argb: '828282' },
        },
      };

      // Date
      const DATE_COLUMN = 9;
      const DATE_ROW = 8;
      worksheet.getCell(DATE_ROW, DATE_COLUMN).value = this.getNameExcelDate();
      let d = new Date();
      let month = d.getMonth() + 1;
      let date = d.getDate() + '/' + (month < 10 ? '0' + month : '' + month) + '/' + d.getFullYear();
      let dateCell = worksheet.getCell(DATE_ROW, DATE_COLUMN + 1);
      dateCell.value = date;
      dateCell.alignment = { vertical: 'middle', horizontal: 'center' };

      //Page
      worksheet.getCell(DATE_ROW + 1, DATE_COLUMN).value = this.translateService.instant('excel.pag');
      const pageCell = worksheet.getCell(DATE_ROW + 1, DATE_COLUMN + 1);
      pageCell.value = workbook.worksheets.length + 1;
      pageCell.style = { alignment: { horizontal: 'left' } };

      // SECOND ROW
      const PERIOD_COLUMN = 4;
      const PERIOD_ROW = 11;
      worksheet.mergeCells(PERIOD_ROW, PERIOD_COLUMN + 1, PERIOD_ROW, PERIOD_COLUMN + 4);
      worksheet.getCell(PERIOD_ROW, PERIOD_COLUMN).value = this.getNameExcelPeriod();
      worksheet.getCell(PERIOD_ROW, PERIOD_COLUMN + 1).value = 'De ' + dates[0] + ' a ' + dates[1];

      worksheet.getCell(PERIOD_ROW + 1, PERIOD_COLUMN).value = this.translateService.instant('excel.product');
      worksheet.getCell(PERIOD_ROW + 1, PERIOD_COLUMN + 1).value = product;
      worksheet.getCell(PERIOD_ROW + 2, PERIOD_COLUMN).value = this.translateService.instant('excel.typeOfGood');
      worksheet.getCell(PERIOD_ROW + 2, PERIOD_COLUMN + 1).value = typeArticle;
    }
  }

  exportExcelAgentStatistics(excelData: any) {
    const maxCharactersLength = 30; //Maximum number of characters allowed until the row height changes
    const rowHeight = 37; //Row's Height when it breaks. We need it due to excel not automatically calculating it.

    const fileName = excelData?.fileName;
    const header = excelData.headers;
    const data: Array<any> = excelData.data;
    const division: string = excelData?.division;
    const product = excelData?.product;
    const typeArticle = excelData?.typeArticle;
    const dates = excelData?.date;
    const workbook = new Workbook();
    const worksheet = this.generateNewWorksheet(workbook, division, product, typeArticle, dates);

    data.forEach((group, index) => {
      if (index !== data.length - 1) {
        this.createHeaderTable(worksheet, header, group);
        group.forEach((item: any, index: number) => {
          for (let i = 0; i < item.length; i++) {
            item[i] = this.checkNumbersFormat(item[i]);
          }
          if (index !== 0) {
            item.splice(2, 0, '');
            const rowInserted = worksheet.addRow(item);
            worksheet.mergeCells(rowInserted.getCell(2).address, rowInserted.getCell(3).address);
            if (index === group.length - 1) {
              this.agentStatisticsRowBorderStyle(rowInserted);
            }
            if (item[1]?.length > maxCharactersLength) {
              rowInserted.height = rowHeight;
            }
          }
        });
        worksheet.addRow([]);
      } else {
        group.forEach((item: any) => {
          for (let i = 0; i < item.length; i++) {
            item[i] = this.checkNumbersFormat(item[i]);
          }
          item.splice(2, 0, '');

          const row = worksheet.addRow(item);
          this.agentStatisticsRowBorderStyle(row);
        });
      }
    });
    worksheet.addRow([]);
    this.generateExcel(fileName, workbook);
  }

  private agentStatisticsRowBorderStyle = (row: Row) => {
    row.eachCell((cell, index) => {
      if (index !== 1) {
        cell.border = {
          top: {
            color: { argb: '000000' },
            style: 'thick',
          },
        };
      }
    });
  };

  private createHeaderTable(worksheet: Worksheet, header: any, group: any) {
    //Declarations
    const officeRow = worksheet.addRow(['Oficina: ', group[0][0], group[0][1]]);
    const headerRow = worksheet.addRow([
      header[0],
      '',
      '',
      header[2],
      header[3],
      header[4],
      header[5],
      header[6],
      header[7],
      header[8],
    ]);

    //Logic
    worksheet.mergeCells(
      officeRow.getCell(officeRow.cellCount).address,
      officeRow.getCell(officeRow.cellCount + 2).address
    );
    worksheet.mergeCells(headerRow.getCell(2).address, headerRow.getCell(3).address); //Due to the second column be composed of B and C, we merge both columns

    //Style
    officeRow.getCell(1).font = { bold: true };
    headerRow.eachCell((cell) => {
      cell.style = {
        alignment: { vertical: 'middle', wrapText: true },
        font: {
          bold: true,
          size: 11.5,
        },
        border: {
          bottom: {
            color: { argb: '000000' },
            style: 'thick',
          },
        },
      };
    });
  }

  private generateNewWorksheet(
    workbook: Workbook,
    division: string,
    product: string,
    typeArticle: string,
    dates: string[]
  ): Worksheet {
    let worksheet = workbook.addWorksheet('Page ' + (workbook.worksheets.length + 1), {
      pageSetup: { paperSize: 9, orientation: 'portrait', fitToPage: true, fitToWidth: 1, fitToHeight: 0 },
    });
    this.headerExcelAgentStatistics(workbook, division, product, typeArticle, dates);

    //We cannot set alignment here since it won't recognise the style changes in other specific rows/columns.
    worksheet.columns.forEach(function (column, i) {
      column.width =
        i === 0
          ? 14
          : i === 1 || i == 2 || i == 4 || i === 7 || i === 9
          ? 16
          : i === 3
          ? 9.5
          : i === 5 || i === 6 || i === 8
          ? 8
          : 0;
      column.alignment = i === 2 ? { wrapText: true } : {};
    });

    worksheet.getRow(15); //We call the row to know where the next 'addRow()' should start.
    return worksheet;
  }

  exporExcelInvestment(excelData: any) {
    const fileName = excelData?.fileName;
    const date = new Date();
    let cont = 18; //first row for the tables
    const data = excelData.data;

    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet(this.translateService.instant('paymentCert.excelPage') + ' 1');
    excelData.totalInvestment = this.checkNumbersFormat(excelData.totalInvestment);
    this.headerExcelInvestment(excelData.searchData, excelData.totalInvestment, workbook, worksheet);
    data.forEach((item: any, index: number) => {
      let keys = Object.keys(item);
      for (let i = 0; i < keys.length; i++) {
        item[keys[i]] = this.checkNumbersFormat(item[keys[i]]);
      }

      //first row
      worksheet.getCell('B' + cont).value = this.translateService.instant('excel.typeOfGood');
      worksheet.mergeCells('C' + cont + ':F' + cont);
      worksheet.getCell('C' + cont).style = { alignment: { shrinkToFit: true } };
      worksheet.getCell('C' + cont).value = item.sectorId + ' ' + item.serctorDescription;
      worksheet.mergeCells('I' + cont + ':M' + cont);
      worksheet.getCell('I' + cont).value = '% sobre Inv. total:';
      worksheet.getCell('N' + cont).value = item.percentInTotalInversion;
      worksheet.getCell('N' + cont).alignment = { vertical: 'middle', horizontal: 'right' };

      //second row
      cont++;
      const columnLetters = 'GHIJKLMNOP'.split('');
      const tableHeaders = [
        this.translateService.instant('generalOfInvestment.numOperations'),
        this.translateService.instant('generalOfInvestment.investment'),
        this.translateService.instant('generalOfInvestment.percentageOverTotal'),
        this.translateService.instant('generalOfInvestment.averagePl'),
        this.translateService.instant('generalOfInvestment.averageTIR'),
      ];

      worksheet.mergeCells('B' + cont + ':F' + cont);
      worksheet.getCell('B' + cont).value = this.translateService.instant('generalOfInvestment.calification');
      worksheet.mergeCells('B' + (cont + 1) + ':F' + (cont + 1));
      worksheet.getCell('B' + (cont + 1)).value = item.sectorId + ' ' + item.serctorDescription;
      worksheet.mergeCells('B' + (cont + 2) + ':F' + (cont + 2));
      worksheet.getCell('B' + (cont + 2)).value = this.translateService.instant('generalOfInvestment.totals');
      worksheet.getCell('B' + (cont + 2)).font = { bold: true };
      worksheet.getCell('B' + (cont + 2)).alignment = { vertical: 'middle', horizontal: 'right' };

      for (let i = 0; i < columnLetters.length; i = i + 2) {
        //set headers of the table
        const letter1 = columnLetters[i];
        const letter2 = columnLetters[i + 1];
        worksheet.mergeCells(letter1 + cont + ':' + letter2 + cont);
        worksheet.getCell(letter1 + cont).style = { border: { bottom: { style: 'thick' } }, font: { bold: true } };
        worksheet.getCell(letter2 + cont).style = { border: { bottom: { style: 'thick' } } };
        worksheet.getCell(letter1 + cont).value = tableHeaders[i / 2]; //not a problem because i always adds up to 2

        worksheet.mergeCells(letter1 + (cont + 1) + ':' + letter2 + (cont + 1));
        worksheet.getCell(letter1 + (cont + 1)).style = { border: { bottom: { style: 'thick' } } };
        worksheet.getCell(letter2 + (cont + 1)).style = { border: { bottom: { style: 'thick' } } };
        worksheet.mergeCells(letter1 + (cont + 2) + ':' + letter2 + (cont + 2));

        switch (i / 2) {
          case 0:
            worksheet.getCell(letter1 + (cont + 1)).value = item.numOperations;

            worksheet.getCell(letter1 + (cont + 2)).value = item.numOperations;
            break;
          case 1:
            worksheet.getCell(letter1 + (cont + 1)).value = item.inversion;

            worksheet.getCell(letter1 + (cont + 2)).value = item.inversion;
            break;
          case 2:
            worksheet.getCell(letter1 + (cont + 1)).value = item.totalPortion;
            break;
          case 3:
            worksheet.getCell(letter1 + (cont + 1)).value = item.termsAverage;

            worksheet.getCell(letter1 + (cont + 2)).value = item.termsAverage;
            break;
          case 4:
            worksheet.getCell(letter1 + (cont + 1)).value = item.tirAverage;

            worksheet.getCell(letter1 + (cont + 2)).value = item.tirAverage;
            break;
          default:
            break;
        }
      }
      cont = cont + 4;
    });
    this.generateExcel(fileName, workbook);
  }

  headerExcelInvestment(searchData: string[], total: string, workbook: Workbook, worksheet: Worksheet) {
    //Add Row and formatting
    worksheet.mergeCells('F3', 'S4');
    let titleRow = worksheet.getCell('F3');
    titleRow.value = this.getTitleDashboardReport();
    titleRow.font = {
      name: 'Calibri',
      size: 30,
      bold: true,
      color: { argb: '1E90FF' },
    };
    titleRow.alignment = { vertical: 'middle', horizontal: 'center' };

    // Date
    worksheet.mergeCells('O7:P7');
    worksheet.getCell('O7').value = this.getNameExcelDate();
    worksheet.getCell('O7').font = {
      bold: true,
    };
    worksheet.getCell('O7').alignment = { vertical: 'middle', horizontal: 'right' };

    let d = new Date();
    let month = d.getMonth() + 1;
    let date = d.getDate() + '/' + (month < 10 ? '0' + month : '' + month) + '/' + d.getFullYear();
    worksheet.mergeCells('Q7:R7');
    let dateCell = worksheet.getCell('Q7');
    dateCell.value = date;
    dateCell.alignment = { vertical: 'middle', horizontal: 'left' };

    //page
    worksheet.mergeCells('O8:P8');
    worksheet.getCell('O8').value = this.translateService.instant('excel.page');
    worksheet.getCell('O8').font = {
      bold: true,
    };
    worksheet.getCell('O8').alignment = { vertical: 'middle', horizontal: 'right' };

    worksheet.mergeCells('Q8:R8');
    worksheet.getCell('Q8').value = worksheet.id;
    dateCell.alignment = { vertical: 'middle', horizontal: 'right' };

    //Add Image
    let myLogoImage = workbook.addImage({
      base64: logo,
      extension: 'png',
    });
    worksheet.mergeCells('B2:D5');
    worksheet.addImage(myLogoImage, 'B2:D5');

    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);

    //Add data from search
    if (worksheet.id === 1) {
      worksheet.mergeCells('G7:M8');
      worksheet.getCell('G7').font = {
        size: 18,
        bold: true,
        color: { argb: '969696' },
      };
      worksheet.getCell('G7').value = this.translateService.instant('generalOfInvestment.listOfInvestment');

      const titleRows = [
        this.getNameExcelOffice(),
        this.getNameExcelPeriod(),
        this.translateService.instant('excel.product'),
        this.translateService.instant('excel.origin'),
        this.translateService.instant('excel.typeOfGood'),
        this.getNameExcelDivision(),
        this.translateService.instant('excel.currency'),
      ];
      const firstRow = 10;
      for (let i = firstRow; i < firstRow + titleRows.length; i++) {
        //set titles
        worksheet.getCell('B' + i).value = titleRows[i - 10];
        worksheet.getCell('B' + i).font = { bold: true };
        worksheet.getCell('B' + i).alignment = { vertical: 'middle', horizontal: 'right' };
        //set values
        worksheet.mergeCells('C' + i + ':H' + i);
        worksheet.getCell('C' + i).value = searchData[i - 10];
      }
      worksheet.mergeCells('M16:N16');
      let totalTitleCell = worksheet.getCell('M16');
      totalTitleCell.value = this.translateService.instant('generalOfInvestment.total');
      totalTitleCell.alignment = { vertical: 'middle', horizontal: 'right' };
      totalTitleCell.font = { bold: true };

      worksheet.mergeCells('O16:Q16');
      let totalValueCell = worksheet.getCell('O16');
      totalValueCell.value = total;
      totalValueCell.alignment = { vertical: 'middle', horizontal: 'left' };
    }
  }

  exportExcelOperationDetail(excelData: any) {
    //Title, Header & Data
    const title = this.getTitleDashboardReport();
    const fileName = excelData?.fileName;
    const header = excelData.headers;
    const data = excelData.data;
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet(this.translateService.instant('excel.dashboard.sheetOne'));

    let contTables = 0;

    data.forEach((item: any) => {
      item.operations.forEach((element: any, index: number) => {
        for (let i = 0; i < element.length; i++) {
          element[i] = this.checkNumbersFormat(element[i]);
        }
        if (contTables === 0) {
          this.headerOperationDetail(title, excelData.criteria, workbook, worksheet);
        }

        if (index === 0 || contTables === 0) {
          this.tableHeadersOperationDetail(header, item.status, worksheet);
        }

        let dataRow = worksheet.addRow(Object.values(element));
        if (item.operations.length - 1 === index) {
          dataRow.eachCell((cell) => {
            cell.style = {
              alignment: { vertical: 'middle', horizontal: 'center', wrapText: true },
              border: { top: { style: 'thick' } },
              font: { bold: true },
            };
          });
        } else {
          dataRow.eachCell((cell) => {
            cell.style = {
              alignment: { vertical: 'middle', horizontal: 'center', wrapText: true },
            };
          });
        }
        contTables++;
      });
    });
    this.generateExcel(fileName, workbook);
  }

  headerOperationDetail(title: any, searchData: OperationDetailRequestDTO, workbook: Workbook, worksheet: Worksheet) {
    //Add Row and formatting
    worksheet.mergeCells('E1', 'J5');
    let titleRow = worksheet.getCell('E1');
    titleRow.value = title;
    titleRow.font = {
      name: 'Calibri',
      size: 25,
      bold: true,
      color: { argb: '1E90FF' },
    };
    titleRow.alignment = { vertical: 'middle', horizontal: 'center' };

    // Date and page
    worksheet.getCell('J7').value = this.getPaymentReportTableDate();
    worksheet.getCell('J7').style = { alignment: { vertical: 'middle', horizontal: 'right' }, font: { bold: true } };
    let d = new Date();
    let month = d.getMonth() + 1;
    let date = d.getDate() + '/' + (month < 10 ? '0' + month : '' + month) + '/' + d.getFullYear();
    let dateCell = worksheet.getCell('K7');
    dateCell.value = date;
    dateCell.style = { alignment: { vertical: 'middle', horizontal: 'left' } };

    worksheet.getCell('J8').value = this.getPaymentReportPag();
    worksheet.getCell('J8').style = { alignment: { vertical: 'middle', horizontal: 'right' }, font: { bold: true } };
    worksheet.getCell('K8').value = worksheet.id;
    worksheet.getCell('K8').style = { alignment: { vertical: 'middle', horizontal: 'left' } };

    //Add Image
    let myLogoImage = workbook.addImage({
      base64: logo,
      extension: 'png',
    });
    worksheet.mergeCells('A1:C5');
    worksheet.addImage(myLogoImage, { tl: { col: 0, row: 0 }, ext: { width: 210, height: 90 } });

    if (worksheet.id === 1) {
      //Add period
      worksheet.getCell('A7').value = this.getNameExcelPeriod();
      worksheet.getCell('A7').style = { alignment: { vertical: 'middle', horizontal: 'right' }, font: { bold: true } };
      worksheet.getCell('B7').value = 'Del ' + searchData.fromDate + ' al ' + searchData.toDate;
      worksheet.getCell('B7').style = { alignment: { vertical: 'middle', horizontal: 'left' } };

      //Add office
      worksheet.getCell('A8').value = 'Oficina:';
      worksheet.getCell('A8').style = { alignment: { vertical: 'middle', horizontal: 'right' }, font: { bold: true } };
      worksheet.getCell('B8').value = searchData.officeId;
      worksheet.getCell('B8').style = { alignment: { vertical: 'middle', horizontal: 'left' } };

      //Add status
      worksheet.getCell('A9').value = this.translateService.instant('excel.status');
      worksheet.getCell('A9').style = { alignment: { vertical: 'middle', horizontal: 'right' }, font: { bold: true } };
      worksheet.getCell('B9').value = searchData.reqStatusId;
      worksheet.getCell('B9').style = { alignment: { vertical: 'middle', horizontal: 'left' } };

      //Add group
      worksheet.getCell('A10').value = this.translateService.instant('excel.group');
      worksheet.getCell('A10').style = { alignment: { vertical: 'middle', horizontal: 'right' }, font: { bold: true } };
      worksheet.getCell('B10').value = searchData.groupId;
      worksheet.getCell('B10').style = { alignment: { vertical: 'middle', horizontal: 'left' } };

      //Add agent
      worksheet.getCell('A11').value = this.translateService.instant('excel.agent');
      worksheet.getCell('A11').style = { alignment: { vertical: 'middle', horizontal: 'right' }, font: { bold: true } };
      worksheet.getCell('B11').value = searchData.agentId;
      worksheet.getCell('B11').style = { alignment: { vertical: 'middle', horizontal: 'left' } };

      //Add external commercial
      worksheet.getCell('A12').value = this.translateService.instant('excel.comercialExt');
      worksheet.getCell('A12').style = { alignment: { vertical: 'middle', horizontal: 'right' }, font: { bold: true } };
      worksheet.getCell('B12').value = searchData.extCommercialId;
      worksheet.getCell('B12').style = { alignment: { vertical: 'middle', horizontal: 'left' } };

      //Add origin
      worksheet.getCell('A13').value = 'Origen:';
      worksheet.getCell('A13').style = { alignment: { vertical: 'middle', horizontal: 'right' }, font: { bold: true } };
      worksheet.getCell('B13').value = searchData.origin;
      worksheet.getCell('B13').style = { alignment: { vertical: 'middle', horizontal: 'left' } };

      worksheet.mergeCells('E7:H8');
      worksheet.getCell('E7').value = this.translateService.instant('operationDetail.title');
      worksheet.getCell('E7').style = {
        alignment: { vertical: 'middle', horizontal: 'center' },
        font: { name: 'Calibri', size: 18, bold: true, underline: 'single', color: { argb: '828282' } },
      };
    }
  }

  tableHeadersOperationDetail(headers: string[], status: string, worksheet: Worksheet) {
    //Add table title
    worksheet.addRow([]);
    worksheet.addRow([]);
    let titleRow = worksheet.addRow([status]);
    titleRow.eachCell((cell, number) => {
      cell.style = {
        alignment: { horizontal: 'left' },
        font: {
          name: 'Calibri',
          size: 12,
          bold: true,
          underline: 'single',
          color: { argb: '828282' },
        },
      };
    });

    //Adding Header Row
    let headerRow = worksheet.addRow(headers);
    headerRow.eachCell((cell, number) => {
      cell.style = {
        alignment: { horizontal: 'center', vertical: 'middle', wrapText: true },
        fill: {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '969696' },
          bgColor: { argb: '' },
        },
        font: {
          bold: true,
          color: { argb: 'FFFFFF' },
          size: 12,
        },
      };
    });

    worksheet.columns.forEach((column, i) => {
      column.width =
        i === 12 || i === 14
          ? 10
          : i === 0 || i === 1 || i === 2 || i === 3 || i === 4 || i === 9
          ? 16
          : i === 10 || i === 5 || i === 6 || i === 11 || i === 16 || i === 7
          ? 12
          : 8;
    });
  }

  exportExcelActionAgent(excelData: ActionAgentExcelData[], criteria: AgentActionPlanSearchDTO) {
    //Title, Header & Data
    const title = this.getTitleDashboardReport();
    const fileName =
      this.translateService.instant('actionAgent.excel.title') + moment().locale('es').format('DDMMYYYY');
    const data = excelData;

    let workbook = new Workbook();
    const worksheet = workbook.addWorksheet(this.translateService.instant('excel.dashboard.sheetOne'));

    this.headerActionAgent(title, criteria, workbook, worksheet);
    data.forEach((item: ActionAgentExcelData) => {
      item.column.forEach((element: any, index: number) => {
        if (index === 0) {
          this.tableHeadersActionAgent(item.header, item.title, worksheet);
        }
        let dataRow = worksheet.addRow(Object.values(element));
        dataRow.eachCell((cell, number) => {
          cell.style = {
            alignment: { vertical: 'middle', horizontal: 'center', wrapText: true },
            fill: {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: index % 2 === 0 ? 'd1d1d1' : 'ffffff' },
              bgColor: { argb: '' },
            },
          };
        });
      });
    });
    this.generateExcel(fileName, workbook);
  }

  headerActionAgent(title: string, searchData: AgentActionPlanSearchDTO, workbook: Workbook, worksheet: Worksheet) {
    //Add Row and formatting
    worksheet.mergeCells('E1', 'L5');
    let titleRow = worksheet.getCell('E1');
    titleRow.value = title;
    titleRow.font = {
      name: 'Calibri',
      size: 25,
      bold: true,
      color: { argb: '1E90FF' },
    };
    titleRow.alignment = { vertical: 'middle', horizontal: 'center' };

    // Date and page
    worksheet.getCell('K7').value = this.getNameExcelDate();
    worksheet.getCell('K7').style = { alignment: { vertical: 'middle', horizontal: 'right' }, font: { bold: true } };
    let d = new Date();
    let month = d.getMonth() + 1;
    let date = d.getDate() + '/' + (month < 10 ? '0' + month : '' + month) + '/' + d.getFullYear();
    let dateCell = worksheet.getCell('L7');
    dateCell.value = date;
    dateCell.style = { alignment: { vertical: 'middle', horizontal: 'left' } };

    worksheet.getCell('K8').value = this.translateService.instant('excel.pag');
    worksheet.getCell('K8').style = { alignment: { vertical: 'middle', horizontal: 'right' }, font: { bold: true } };
    worksheet.getCell('L8').value = worksheet.id;
    worksheet.getCell('L8').style = { alignment: { vertical: 'middle', horizontal: 'left' } };

    //Add Image
    let myLogoImage = workbook.addImage({
      base64: logo,
      extension: 'png',
    });
    worksheet.mergeCells('A1:C5');
    worksheet.addImage(myLogoImage, { tl: { col: 0, row: 0 }, ext: { width: 210, height: 90 } });

    if (worksheet.id === 1) {
      //Add division
      worksheet.getCell('A7').value = this.getNameExcelDivision();
      worksheet.getCell('A7').style = { alignment: { vertical: 'middle', horizontal: 'right' }, font: { bold: true } };
      worksheet.getCell('B7').value = searchData.divisionId.value;
      worksheet.getCell('B7').style = { alignment: { vertical: 'middle', horizontal: 'left' } };

      //Add office
      worksheet.getCell('A8').value = this.getNameExcelOffice();
      worksheet.getCell('A8').style = { alignment: { vertical: 'middle', horizontal: 'right' }, font: { bold: true } };
      worksheet.getCell('B8').value = searchData.officeId.value;
      worksheet.getCell('B8').style = { alignment: { vertical: 'middle', horizontal: 'left' } };

      //Add group
      worksheet.getCell('A9').value = this.translateService.instant('excel.group');
      worksheet.getCell('A9').style = { alignment: { vertical: 'middle', horizontal: 'right' }, font: { bold: true } };
      worksheet.getCell('B9').value = searchData.chainId.value;
      worksheet.getCell('B9').style = { alignment: { vertical: 'middle', horizontal: 'left' } };

      //Add nifcif
      worksheet.getCell('A10').value = this.translateService.instant('excel.nifcif');
      worksheet.getCell('A10').style = { alignment: { vertical: 'middle', horizontal: 'right' }, font: { bold: true } };
      worksheet.getCell('B10').value = searchData.prescriberId.value;
      worksheet.getCell('B10').style = { alignment: { vertical: 'middle', horizontal: 'left' } };

      //Add punto de venta
      worksheet.getCell('A11').value = this.translateService.instant('excel.pointOfSale');
      worksheet.getCell('A11').style = { alignment: { vertical: 'middle', horizontal: 'right' }, font: { bold: true } };
      worksheet.getCell('B11').value = searchData.establishmentId.value;
      worksheet.getCell('B11').style = { alignment: { vertical: 'middle', horizontal: 'left' } };

      //Add comercial externo
      worksheet.getCell('A12').value = this.translateService.instant('excel.comercialExt');
      worksheet.getCell('A12').style = { alignment: { vertical: 'middle', horizontal: 'right' }, font: { bold: true } };
      worksheet.getCell('B12').value = searchData.externalCommercialId.value;
      worksheet.getCell('B12').style = { alignment: { vertical: 'middle', horizontal: 'left' } };

      //Add nivel de detalle
      worksheet.getCell('A13').value = this.translateService.instant('actionAgent.levelDetail');
      worksheet.getCell('A13').style = { alignment: { vertical: 'middle', horizontal: 'right' }, font: { bold: true } };

      let translatedText;
      switch (searchData.customerDetail) {
        case 'C':
          translatedText = this.translateService.instant('actionAgent.group');
          break;
        case 'P':
          translatedText = this.translateService.instant('actionAgent.dealer');
          break;
        default:
          translatedText = this.translateService.instant('actionAgent.pointOfSale');
          break;
      }
      worksheet.getCell('B13').value = translatedText;
      worksheet.getCell('B13').style = { alignment: { vertical: 'middle', horizontal: 'left' } };

      worksheet.mergeCells('E7:I8');
      worksheet.getCell('E7').value = this.translateService.instant('actionAgent.title');
      worksheet.getCell('E7').style = {
        alignment: { vertical: 'middle', horizontal: 'center' },
        font: { name: 'Calibri', size: 18, bold: true, underline: 'single', color: { argb: '828282' } },
      };
    }
  }

  tableHeadersActionAgent(headers: string[][], title: string, worksheet: Worksheet) {
    //Add table title
    worksheet.addRow([]);
    worksheet.addRow([]);
    let titleRow = worksheet.addRow([title]);
    titleRow.eachCell((cell, number) => {
      cell.style = {
        alignment: { horizontal: 'left' },
        font: {
          name: 'Calibri',
          size: 12,
          bold: true,
          underline: 'single',
          color: { argb: '828282' },
        },
      };
    });

    headers.forEach((eachHeaderGroup, index) => {
      //Adding Header Row
      let headerRow = worksheet.addRow(eachHeaderGroup);
      headerRow.eachCell((cell, number) => {
        cell.style = {
          alignment: { horizontal: 'center', vertical: 'middle', wrapText: true },
          fill: {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: index % 2 === 0 ? '969696' : 'ffffff' },
            bgColor: { argb: '' },
          },
          font: {
            bold: true,
            color: { argb: index % 2 === 0 ? 'ffffff' : '000000' },
            size: 12,
          },
          border:
            index % 2 !== 0
              ? {
                  bottom: {
                    color: { argb: '000000' },
                    style: 'thick',
                  },
                }
              : {},
        };
      });
    });

    worksheet.columns.forEach((column, i) => {
      column.width = i === 0 ? 17 : i === 1 ? 13 : 9;
    });
  }

  exportExcelAdminReport(excelData: any, text?: string) {
    //Title, Header & Data
    const title = text?.length > 0 ? text : 'Informe Administrador';
    const state = excelData.state;
    const header = excelData.headers;
    const data = excelData.data;

    //Create a workbook with a worksheet
    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet(text?.length > 0 ? text : 'Informe Administrador');

    this.headerExcel(title, header, workbook, worksheet, 'MMM d, y, h:mm:ss a');

    worksheet.mergeCells('A8:B8');
    worksheet.getCell('A8').value = state?.toUpperCase();
    worksheet.getCell('A8').font = {
      name: 'Calibri',
      size: 12,
      bold: true,
    };

    let bodyRows: any;
    let contRow = 0;

    data.map(Object.values).forEach((d: any) => {
      for (let i = 0; i < d.length; i++) {
        d[i] = this.checkNumbersFormat(d[i]);
      }

      bodyRows = worksheet.addRow(d);

      bodyRows.eachCell((cell: any, number: any) => {
        cell.border = {
          right: { style: 'thick' },
        };
        if (contRow === 0) {
          cell.border = {
            top: { style: 'thick' },
            right: { style: 'thick' },
          };
        }
      });
      contRow++;
    });

    worksheet.addRow([]);

    worksheet.columns.forEach((column) => {
      let maxColumnLength = 0;
      column.eachCell({ includeEmpty: true }, (cell) => {
        maxColumnLength = Math.max(maxColumnLength, 8, cell.value ? cell.value.toString().length : 0);
      });
      column.width = maxColumnLength + 2;
    });

    this.generateExcel(
      (text?.length > 0 ? text + '_' : 'InformeAdministrador_') + this.datePipe.transform(new Date(), 'ddMMyyyy'),
      workbook
    );
  }

  exportExcelPaymentCert(excelData: any) {
    const title = this.translateService.instant('paymentCert.report');
    let header = excelData.data.headers as String[];
    const data: any = excelData.data.data.map((element: any) => {
      return JSON.parse(JSON.stringify(element));
    });

    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet('Hoja 1');

    for (let i = 0; i < data.length; i++) {
      if (i === 0) {
        this.headerExcelPaymentCert(title, header, workbook, worksheet, excelData);
        worksheet.columns.forEach((column) => {
          column.width = 20;
        });
      }

      let dataExcelOrder = JSON.stringify(data[i], ['date', 'amount', 'state']);

      const objectDataExcel = JSON.parse(dataExcelOrder);
      let dataRow = worksheet.addRow(Object.values(objectDataExcel));
      dataRow.eachCell((cell, number) => {
        cell.style = {
          alignment: { vertical: 'middle', horizontal: 'center', wrapText: true },
        };
      });
    }

    this.generateExcel(title, workbook);
  }

  headerExcelPaymentCert(title: any, header: any, workbook: Workbook, worksheet: Worksheet, excelData: any) {
    //Add title
    let titleRow = worksheet.getCell('E1');
    titleRow.value = this.translateService.instant('paymentCert.report');
    if (titleRow.value.toString().length < 30) {
      worksheet.mergeCells('E1', 'G5');
    } else {
      worksheet.mergeCells('E1', 'H5');
    }
    titleRow.font = {
      name: 'Calibri',
      size: 25,
      bold: true,
      color: { argb: '1E90FF' },
    };
    titleRow.alignment = { vertical: 'middle', horizontal: 'center' };

    // Date and page
    worksheet.getCell('E7').value = this.translateService.instant('paymentCert.date') + ':';
    worksheet.getCell('E7').style = { alignment: { vertical: 'middle', horizontal: 'right' }, font: { bold: true } };
    let d = new Date();
    let month = d.getMonth() + 1;
    let date = d.getDate() + '/' + (month < 10 ? '0' + month : '' + month) + '/' + d.getFullYear();
    let dateCell = worksheet.getCell('F7');
    dateCell.value = date;
    dateCell.style = { alignment: { vertical: 'middle', horizontal: 'left' } };

    worksheet.getCell('E8').value = this.translateService.instant('paymentCert.excelPage') + ': ';
    worksheet.getCell('E8').style = { alignment: { vertical: 'middle', horizontal: 'right' }, font: { bold: true } };
    worksheet.getCell('F8').value = worksheet.id;
    worksheet.getCell('F8').style = { alignment: { vertical: 'middle', horizontal: 'left' } };

    //Add Image
    let myLogoImage = workbook.addImage({
      base64: logo,
      extension: 'png',
    });
    worksheet.mergeCells('A1:B5');
    worksheet.addImage(myLogoImage, 'A1:B5');

    //Adding Header Row
    worksheet.addRow([]);
    let headerRow = worksheet.addRow(header);
    headerRow.eachCell((cell, number) => {
      cell.style = {
        alignment: { horizontal: 'center', vertical: 'middle' },
        fill: {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '969696' },
          bgColor: { argb: '' },
        },
        font: {
          bold: true,
          color: { argb: 'FFFFFF' },
          size: 12,
        },
      };
    });
  }

  exportExcelPaymentReport(excelData: any) {
    //Title, Header & Data
    const title =
      this.translateService.instant('paymentReports.table.excelTitle') + moment().locale('es').format('DDMMYYYY');
    let header = excelData.data.headers as String[];
    // const data: Array<any> = excelData.data.data;
    const data: any = excelData.data.data.map((element: any) => {
      return JSON.parse(JSON.stringify(element));
    });
    if (excelData.division.toString() === FINANCIAL_PRODUCT_AUTO) {
      header = header.filter((e) => e != this.translateService.instant('paymentReports.table.financialCosts'));
      excelPaymentReportData = excelPaymentReportData.filter((e) => e != 'financialExpenses');
    }
    for (let i = 0; i < data.length; i++) {}
    let workbook = new Workbook();

    let worksheet = workbook.addWorksheet('Hoja 1');

    for (let i = 0; i < data.length; i++) {
      let keys = Object.keys(data[i]);
      for (let j = 0; j < keys.length; j++) {
        if (keys[j] !== 'paymentDate') {
          data[i][keys[j]] = this.checkNumbersFormat(data[i][keys[j]]);
        }
      }
      if (i === 0) {
        this.headerExcelPaymentReport(title, header, workbook, worksheet, excelData);
        worksheet.columns.forEach(function (column, i) {
          column.width =
            i === 0 || i === 8 || i === 11
              ? 19
              : i === 6 || i === 7
              ? 15
              : i === 1 || i === 2 || i === 3 || i == 4 || i === 5 || i === 9 || i === 10 || i === 12 || i === 13
              ? 17
              : i === 11 || i === 14 || i === 15 || i === 16
              ? 13
              : 0;
          column.alignment = i === 2 ? { wrapText: true } : {};
        });
      }
      let dataExcelOrder;
      if (excelData.division.toString() === FINANCIAL_PRODUCT_C) {
        dataExcelOrder = JSON.stringify(data[i], [
          'paymentDate', //fecha pago
          'lot',
          'numOperation',
          'contractId', //referencia¿?
          'establishment',
          'company',
          'cifBeneficiary', //establecimiento y nombre?
          'recipient', //beneficiario / destinatario
          'netAmount', //importe
          'amount',
          'financialExpenses',
          'titleholder', //titular
          'description', //descripcion
          'contractId', //referencia¿?
          'reference', //campo referencia
          'reference2',
          'idOwnStoreAgreement', //id_tienda
          'operative',
        ]);
      } else {
        dataExcelOrder = JSON.stringify(data[i], [
          'paymentDate', //fecha pago
          'lot',
          'numOperation',
          'contractId', //referencia¿?
          'establishment',
          'company',
          'cifBeneficiary', //establecimiento y nombre?
          'recipient', //beneficiario / destinatario
          'netAmount', //importe
          'amount',
          'titleholder', //titular
          'description', //descripcion
          'contractId', //referencia¿?
          'reference', //campo referencia
          'reference2',
          'idOwnStoreAgreement', //id_tienda
          'operative',
        ]);
      }
      const objectDataExcel = JSON.parse(dataExcelOrder);
      let dataRow = worksheet.addRow(Object.values(objectDataExcel));
      dataRow.eachCell((cell, number) => {
        cell.style = {
          alignment: { vertical: 'middle', horizontal: 'center', wrapText: true },
        };
      });
    }

    this.generateExcel(title, workbook);
  }

  headerExcelPaymentReport(title: any, header: any, workbook: Workbook, worksheet: Worksheet, excelData: any) {
    //Add Row and formatting
    worksheet.mergeCells('A9', 'C11');
    let titleRow = worksheet.getCell('A9');
    titleRow.value = this.translateService.instant('paymentReports.title');
    titleRow.font = {
      name: 'Calibri',
      size: 25,
      bold: true,
      color: { argb: '1E90FF' },
    };
    titleRow.alignment = { vertical: 'middle', horizontal: 'center' };

    // Date and page
    worksheet.getCell('K6').value = this.getPaymentReportTableDate();
    worksheet.getCell('K6').style = { alignment: { vertical: 'middle', horizontal: 'right' }, font: { bold: true } };
    worksheet.mergeCells('L6:N6');
    let d = new Date();
    let month = d.getMonth() + 1;
    let date = d.getDate() + '/' + (month < 10 ? '0' + month : '' + month) + '/' + d.getFullYear();
    let dateCell = worksheet.getCell('L6');
    dateCell.value = date;
    dateCell.style = { alignment: { vertical: 'middle', horizontal: 'left' } };

    worksheet.getCell('K7').value = this.getPaymentReportPag();
    worksheet.getCell('K7').style = { alignment: { vertical: 'middle', horizontal: 'right' }, font: { bold: true } };
    worksheet.getCell('L7').value = worksheet.id;
    worksheet.getCell('L7').style = { alignment: { vertical: 'middle', horizontal: 'left' } };

    //Add Image
    let myLogoImage = workbook.addImage({
      base64: logo,
      extension: 'png',
    });
    worksheet.mergeCells('A1:C7');
    worksheet.addImage(myLogoImage, 'A1:C7');

    if (worksheet.id === 1) {
      //Add search criteria
      worksheet.mergeCells('A13:C13');
      worksheet.getCell('A13').value = 'Del ' + excelData.searchData.dateFrom + ' al ' + excelData.searchData.dateTo;

      //Add totals
      worksheet.getCell('A14').value = this.translateService.instant('paymentReports.infoPayments.paymentsDone');
      worksheet.getCell('A14').style = { alignment: { vertical: 'middle', horizontal: 'right' }, font: { bold: true } };
      worksheet.getCell('B14').value = excelData.realizedPayments;
      worksheet.getCell('B14').style = { alignment: { vertical: 'middle', horizontal: 'left' } };

      worksheet.getCell('D14').value = this.translateService.instant('paymentReports.table.totalAmount');
      worksheet.getCell('D14').style = { alignment: { vertical: 'middle', horizontal: 'right' }, font: { bold: true } };
      worksheet.getCell('E14').value = excelData.amountTotal;
      worksheet.getCell('E14').style = { alignment: { vertical: 'middle', horizontal: 'left' } };
    }

    //Adding Header Row
    worksheet.addRow([]);
    let headerRow = worksheet.addRow(header);
    headerRow.eachCell((cell, number) => {
      cell.style = {
        alignment: { horizontal: 'center', vertical: 'middle' },
        fill: {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '969696' },
          bgColor: { argb: '' },
        },
        font: {
          bold: true,
          color: { argb: 'FFFFFF' },
          size: 12,
        },
      };
    });
  }

  public exportExcelMacrosReport(excelData: any) {
    //Title, Header & Data
    const title = this.translateService.instant('tracingReports.excelTitle') + moment().locale('es').format('DDMMYYYY');
    let header: string[] = [];
    excelData.data.headers.forEach((element: string) => {
      header.push(this.translateService.instant('tracingReports.' + element));
    });

    const data: any = excelData.data.data;

    let workbook = new Workbook();

    let worksheet = workbook.addWorksheet('Hoja 1');

    const excelTitle = this.translateService.instant('tracingReports.table.excelTitle');

    this.headerExcelMacrosReport(excelTitle, header, workbook, worksheet, excelData);
    worksheet.columns.forEach(function (column, i) {
      column.width = 20;
    });

    for (let i = 0; i < data.length; i++) {
      const dataExcel = (excelData.data.headers as string[]).map((header) => {
        return (data[i] as MacroReportResponseAuxDTO)[header];
      });

      let dataRow = worksheet.addRow(dataExcel);
      dataRow.eachCell((cell, number) => {
        cell.style = {
          alignment: { vertical: 'middle', horizontal: 'center', wrapText: true },
        };
      });
    }

    this.generateExcel(title, workbook);
  }

  headerExcelMacrosReport(title: any, header: any, workbook: Workbook, worksheet: Worksheet, excelData: any) {
    //Add Row and formatting

    worksheet.mergeCells('E1', 'G5');
    let titleRow = worksheet.getCell('E1');
    titleRow.value = title;
    titleRow.font = {
      name: 'Calibri',
      size: 30,
      bold: true,
      color: { argb: '1E90FF' },
    };
    titleRow.alignment = { vertical: 'middle', horizontal: 'center' };

    // Date and page
    worksheet.getCell('E6').value = this.translateService.instant('tracingReports.table.excelDate');
    worksheet.getCell('E6').style = { alignment: { vertical: 'middle', horizontal: 'right' }, font: { bold: true } };
    worksheet.mergeCells('F6:G6');
    let d = new Date();
    let month = d.getMonth() + 1;
    let date = d.getDate() + '/' + (month < 10 ? '0' + month : '' + month) + '/' + d.getFullYear();
    let dateCell = worksheet.getCell('F6');
    dateCell.value = date;
    dateCell.style = { alignment: { vertical: 'middle', horizontal: 'left' } };

    worksheet.getCell('E7').value = this.translateService.instant('tracingReports.table.excelPage');
    worksheet.getCell('E7').style = { alignment: { vertical: 'middle', horizontal: 'right' }, font: { bold: true } };
    worksheet.getCell('F7').value = worksheet.id;
    worksheet.getCell('F7').style = { alignment: { vertical: 'middle', horizontal: 'left' } };

    //Add Image
    let myLogoImage = workbook.addImage({
      base64: logo,
      extension: 'png',
    });
    worksheet.mergeCells('A1:B5');
    worksheet.addImage(myLogoImage, 'A1:B5');

    if (worksheet.id === 1) {
      //Add period
      worksheet.getCell('A7').value = this.translateService.instant('tracingReports.table.excelPeriod');
      worksheet.getCell('A7').style = { alignment: { vertical: 'middle', horizontal: 'right' }, font: { bold: true } };
      worksheet.getCell('B7').value =
        this.translateService.instant('tracingReports.table.excelFromDate') +
        ' ' +
        excelData.dateFrom +
        ' ' +
        this.translateService.instant('tracingReports.table.excelToDate') +
        ' ' +
        excelData.dateTo;
      worksheet.getCell('B7').style = { alignment: { vertical: 'middle', horizontal: 'left' } };

      //Add status
      worksheet.getCell('A8').value = this.translateService.instant('tracingReports.table.excelState');
      worksheet.getCell('A8').style = { alignment: { vertical: 'middle', horizontal: 'right' }, font: { bold: true } };
      worksheet.getCell('B8').value = excelData.searchStatus;
      worksheet.getCell('B8').style = { alignment: { vertical: 'middle', horizontal: 'left' } };
    }

    //Add table title
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.mergeCells('A11:C11');
    worksheet.getCell('A11').value = this.translateService.instant('tracingReports.table.excelTitle');
    worksheet.getCell('A11').style = {
      alignment: { horizontal: 'left' },
      font: {
        name: 'Calibri',
        size: 12,
        bold: true,
        underline: 'single',
        color: { argb: '828282' },
      },
    };

    //Adding Header Row
    let headerRow = worksheet.addRow(header);
    headerRow.eachCell((cell, number) => {
      cell.style = {
        alignment: { horizontal: 'center', vertical: 'middle', wrapText: true },
        fill: {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '969696' },
          bgColor: { argb: '' },
        },
        font: {
          bold: true,
          color: { argb: 'FFFFFF' },
          size: 12,
        },
      };
    });
  }

  headerExcelTariffSheet(
    title: string,
    subtitle: string,
    workbook: Workbook,
    worksheet: Worksheet,
    imageEndCoord: string,
    dateCoord: string,
    lastCell: string,
    urlCoord: string[],
    tariff?: string
  ) {
    // Date
    let dateCell = worksheet.getCell(dateCoord);
    dateCell.value = this.datePipe.transform(new Date(), 'MMM d, y, h:mm:ss'); //TODO-Jed: Change date
    dateCell.font = {
      name: 'Arial',
      size: 9,
    };
    dateCell.alignment = { vertical: 'middle', horizontal: 'center' };

    //Add Image
    const imageCoordStart = 'C1';
    const imageCoordEnd = imageEndCoord;
    let myLogoImage = workbook.addImage({
      base64: logo,
      extension: 'png',
    });
    worksheet.mergeCells(imageCoordStart + ':' + imageCoordEnd);
    worksheet.addImage(myLogoImage, imageCoordStart + ':' + imageCoordEnd);

    worksheet.addRow([]);

    const startFirstHeader = 'C5';

    const firstHeader = worksheet.getCell(startFirstHeader);
    firstHeader.style = {
      alignment: { vertical: 'middle', horizontal: 'center' },
      border: {
        top: {
          style: 'double',
          color: { argb: 'FFFFFF' },
        },
        left: {
          style: 'double',
          color: { argb: 'FFFFFF' },
        },
        right: {
          style: 'double',
          color: { argb: 'FFFFFF' },
        },
        bottom: {
          style: 'double',
          color: { argb: 'FFFFFF' },
        },
      },
      font: { name: 'Arial Black', bold: true, size: 14, color: { argb: 'FFFFFF' } },
      fill: {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '969696' },
        bgColor: { argb: '969696' },
      },
    };
    worksheet.mergeCells(startFirstHeader + ':' + lastCell + '5');
    firstHeader.value = title;
    worksheet.getRow(5).height = 38;

    // worksheet.getRow(+firstHeader.row).eachCell(
    //   (cell, colNum) =>
    //   (cell.border = {
    //     top: {
    //       style: 'double',
    //       color: { argb: 'FFFFFF' },
    //     },
    //     left: {
    //       style: 'double',
    //       color: { argb: 'FFFFFF' },
    //     },
    //     right: {
    //       style: 'double',
    //       color: { argb: 'FFFFFF' },
    //     },
    //     bottom: {
    //       style: 'double',
    //       color: { argb: 'FFFFFF' },
    //     },
    //   })
    // );

    const startSecondHeder = 'C6';
    worksheet.mergeCells(startSecondHeder + ':' + lastCell + '6');
    const secondHeader = worksheet.getCell(startSecondHeder);
    secondHeader.value = subtitle;

    const secondHeaderRow = worksheet.getRow(6);
    secondHeaderRow.height = 25;
    secondHeader.style = {
      alignment: { vertical: 'middle', horizontal: 'center' },
      font: { name: 'Arial Black', bold: true, size: 11, color: { argb: 'FFFFFF' } },
      fill: {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '969696' },
      },
    };

    worksheet.getRow(+secondHeader.row).eachCell(
      (cell, colNum) =>
        (cell.border = {
          top: {
            style: 'double',
            color: { argb: 'FFFFFF' },
          },
          left: {
            style: 'double',
            color: { argb: 'FFFFFF' },
          },
          right: {
            style: 'double',
            color: { argb: 'FFFFFF' },
          },
          bottom: {
            style: 'double',
            color: { argb: 'FFFFFF' },
          },
        })
    );

    worksheet.mergeCells(urlCoord[0] + ':' + urlCoord[1]);
    const url = worksheet.getCell(urlCoord[0]);
    url.value = { text: 'www.sabadellconsumer.com', hyperlink: 'https://www.sabadellconsumer.com/' };
    url.style = {
      alignment: { vertical: 'middle', horizontal: 'center' },
      font: { name: 'Arial', underline: true, color: { argb: '0000FF' } },
    };

    const tariffRow = worksheet.addRow([]);
    if (tariff) {
      const tariffStart = tariffRow.getCell(3);
      worksheet.mergeCells(tariffStart.$col$row + ':' + lastCell + +tariffStart.row);
      tariffStart.value = tariff;
      tariffStart.style = {
        alignment: { vertical: 'middle', horizontal: 'center' },
        font: { name: 'Arial Black', bold: true, size: 11, color: { argb: 'FFFFFF' } },
        fill: {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '969696' },
        },
      };
      tariffRow.border = {
        bottom: {
          style: 'thick',
          color: { argb: 'FFFFFF' },
        },
      };
    }
  }

  private footerExcelTariffSheet(description: string, contactData: string, worksheet: Worksheet, lastCell: number) {
    worksheet.addRow([]);
    const discountRow = worksheet.addRow([]);
    const firstCellValue = discountRow.getCell(3);
    firstCellValue.style = {
      alignment: { vertical: 'top', wrapText: true },
      font: { name: 'Arial', size: 8 },
      border: {
        top: { style: 'thin', color: { argb: '000000' } },
        bottom: { style: 'thin', color: { argb: '000000' } },
        left: { style: 'thin', color: { argb: '000000' } },
        right: { style: 'thin', color: { argb: '000000' } },
      },
    };

    worksheet.mergeCells(+firstCellValue.row, +firstCellValue.col, +firstCellValue.row + 4, lastCell);
    firstCellValue.value = description;

    worksheet.addRow([]);

    const contactRow = worksheet.addRow([]);
    const contactFirstCell = contactRow.getCell(2);
    contactRow.height = 37;

    worksheet.mergeCells(+contactFirstCell.row, +contactFirstCell.col, +contactFirstCell.row, lastCell + 1);
    contactFirstCell.value = contactData;
    contactFirstCell.style = {
      alignment: { vertical: 'middle', horizontal: 'center' },
      font: { name: 'Arial Black', bold: true, size: 8, color: { argb: 'FFFFFF' } },
      fill: {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '969696' },
        bgColor: { argb: '969696' },
      },
    };
  }

  exportExcelTariffSheetDiscount(excelData: any) {
    //Title, Header & Data
    const fileName = excelData?.fileName;
    const title = excelData?.title;
    const subtitle = excelData?.subtitle;
    const tableHeaders = excelData?.tableHeaders;
    const tableBody = excelData?.tableBody;
    const description = excelData?.description;
    const contact = excelData?.contact;

    const NUM_COLS = 13;

    //Create a workbook with a worksheet
    let workbook = new Workbook();

    let worksheet = workbook.addWorksheet('Page 1', {
      pageSetup: { paperSize: 9, orientation: 'portrait', scale: 70, horizontalCentered: true },
      properties: { defaultColWidth: 7 },
    });

    this.headerExcelTariffSheet(title, subtitle, workbook, worksheet, 'E4', 'J4', 'K', ['F7', 'H7']);

    //TABLE
    //Header
    const headerRow = worksheet.getRow(9);
    headerRow.height = 45;

    let startCol = 3;
    tableHeaders.forEach((header: string) => {
      const cell = headerRow.getCell(startCol);
      cell.value = header;
      startCol += 2;
    });

    headerRow.eachCell({ includeEmpty: false }, (cell, number) => {
      cell.style = {
        border: {
          top: {
            style: 'double',
          },
          left: {
            style: 'double',
          },
          right: {
            style: 'double',
          },
          bottom: {
            style: 'double',
          },
        },
        font: {
          name: 'Arial Black',
          bold: true,
          color: { argb: '000000' },
          size: 11,
        },
        alignment: {
          horizontal: 'center',
          vertical: 'middle',
          wrapText: true,
        },
      };
    });

    tableBody.forEach((item: any) => {
      const bodyRow = worksheet.addRow([]);
      const firstCell = bodyRow.getCell(3);
      const secondCell = bodyRow.getCell(5);
      const thirdCell = bodyRow.getCell(7);
      const fourthCell = bodyRow.getCell(9);
      const fiveCell = bodyRow.getCell(11);

      firstCell.value = item[0];
      secondCell.value = item[1];
      thirdCell.value = item[2];
      fourthCell.value = item[3];
      fiveCell.value = item[4];

      //bodyRow.alignment = { horizontal: 'center', vertical: 'middle' };
      //bodyRow.font = { name: 'Arial' };
      bodyRow.eachCell({ includeEmpty: false }, (cell, index) => {
        cell.style = {
          alignment: { horizontal: 'center', vertical: 'middle' },
          font: { name: 'Arial' },
          border: {
            top: {
              style: 'double',
            },
            left: {
              style: 'double',
            },
            right: {
              style: 'double',
            },
            bottom: {
              style: 'double',
            },
          },
        };
      });
    });

    this.footerExcelTariffSheet(description, contact, worksheet, 11);

    worksheet.columns.forEach((column, i) => {
      column.width =
        i === 6
          ? 26
          : i === 4 || i === 6 || i === 8 || i === 2 || i === 10
          ? 23
          : i === 1 || i === 5 || i === 7 || i === 3 || i === 9
          ? 1
          : 7;
    });

    worksheet.eachRow({ includeEmpty: true }, (row, rowIndex) => {
      for (let cellIndex = 1; cellIndex <= NUM_COLS; cellIndex++) {
        const cell = worksheet.getCell(row.number, cellIndex);
        if (Object.keys(cell.style)?.length === 0) {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFFFFF' },
            bgColor: { argb: 'FFFFFF' },
          };
        }
      }
    });

    this.generateExcel(fileName, workbook);
  }

  exportExcelTariffSheetInterest(excelData: any) {
    //Title, Header & Data
    const fileName = excelData?.fileName;
    const title = excelData?.title;
    const subtitle = excelData?.subtitle;
    const tableHeaders = excelData?.tableHeaders;
    const tableBody = excelData?.tableBody;
    const description = excelData?.description;
    const contact = excelData?.contact;
    const tariff = excelData?.tariff;

    const NUM_COLS = 13;

    //Create a workbook with a worksheet
    let workbook = new Workbook();

    let worksheet = workbook.addWorksheet('Page 1', {
      pageSetup: { paperSize: 9, orientation: 'portrait', scale: 70, horizontalCentered: true },
      properties: { defaultColWidth: 7 },
    });

    this.headerExcelTariffSheet(title, subtitle, workbook, worksheet, 'E4', 'J4', 'K', ['F7', 'H7'], tariff);

    //TABLE
    //Header
    const headerRow = worksheet.getRow(9);
    headerRow.height = 45;

    let startCol = 3;
    tableHeaders.forEach((header: string) => {
      const cell = headerRow.getCell(startCol);
      cell.value = header;
      startCol += 2;
    });

    headerRow.eachCell({ includeEmpty: false }, (cell, number) => {
      cell.style = {
        border: {
          top: {
            style: 'double',
          },
          left: {
            style: 'double',
          },
          right: {
            style: 'double',
          },
          bottom: {
            style: 'double',
          },
        },
        font: {
          name: 'Arial Black',
          bold: true,
          color: { argb: '000000' },
          size: 9,
        },
        alignment: {
          horizontal: 'center',
          vertical: 'middle',
          wrapText: true,
        },
      };
    });

    tableBody.forEach((item: any) => {
      const bodyRow = worksheet.addRow([]);
      const firstCell = bodyRow.getCell(3);
      const secondCell = bodyRow.getCell(5);
      const thirdCell = bodyRow.getCell(7);
      const fourthCell = bodyRow.getCell(9);
      const fifthCell = bodyRow.getCell(11);

      firstCell.value = item[0];
      secondCell.value = item[1];
      thirdCell.value = item[2];
      fourthCell.value = item[3];
      fifthCell.value = item[4];

      //bodyRow.alignment = { horizontal: 'center', vertical: 'middle' };
      //bodyRow.font = { name: 'Arial' };
      bodyRow.eachCell({ includeEmpty: false }, (cell, index) => {
        cell.style = {
          alignment: { horizontal: 'center', vertical: 'middle' },
          font: { name: 'Arial' },
          border: {
            top: {
              style: 'double',
            },
            left: {
              style: 'double',
            },
            right: {
              style: 'double',
            },
            bottom: {
              style: 'double',
            },
          },
        };
      });
    });

    this.footerExcelTariffSheet(description, contact, worksheet, 11);

    worksheet.columns.forEach((column, i) => {
      column.width =
        i === 6
          ? 26
          : i === 4 || i === 6 || i === 8 || i === 2 || i === 10
          ? 23
          : i === 1 || i === 5 || i === 7 || i === 3 || i === 9
          ? 1
          : 7;
    });

    worksheet.eachRow({ includeEmpty: true }, (row, rowIndex) => {
      for (let cellIndex = 1; cellIndex <= NUM_COLS; cellIndex++) {
        const cell = worksheet.getCell(row.number, cellIndex);
        if (Object.keys(cell.style)?.length === 0) {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFFFFF' },
            bgColor: { argb: 'FFFFFF' },
          };
        }
      }
    });

    this.generateExcel(fileName, workbook);
  }

  exportExcelTariffSheet(excelData: any) {
    //Title, Header & Data
    const fileName = excelData?.fileName;
    const title = excelData?.title;
    const subtitle = excelData?.subtitle;
    const tableHeaders = excelData?.tableHeaders;
    const tableBody: TariffSheet[] = excelData?.tableBody;
    const description = excelData?.description;
    const contact = excelData?.contact;
    const tariff = excelData?.tariff;
    const rowHeaders: string[] = excelData?.rowHeaders;
    const properties = excelData?.properties;
    const grayValuePosition = excelData?.position;

    //Create a workbook with a worksheet
    let workbook = new Workbook();

    let worksheet = workbook.addWorksheet('Page 1', {
      pageSetup: { paperSize: 9, orientation: 'landscape', scale: 70, horizontalCentered: true },
      properties: { defaultColWidth: 7 },
    });

    this.headerExcelTariffSheet(title, subtitle, workbook, worksheet, 'H4', 'BH4', 'BK', ['T7', 'AP7'], tariff);

    //TABLE
    //Header
    const headerRow = worksheet.getRow(9);
    const headerHeight = 18;
    headerRow.height = headerHeight;

    const colSize = 5;
    let startCol = 5;
    tableHeaders?.forEach((header: string) => {
      const cell = headerRow.getCell(startCol);
      worksheet.mergeCells(+cell.row, +cell.col, +cell.row, +cell.col + 4);
      cell.value = header;
      startCol += colSize + 1;
    });

    headerRow.eachCell({ includeEmpty: false }, (cell, number) => {
      cell.style = {
        fill: {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '969696' },
          bgColor: { argb: '969696' },
        },
        font: {
          name: 'Arial Black',
          bold: true,
          color: { argb: 'FFFFFF' },
          size: 10,
        },
        alignment: {
          horizontal: 'center',
          vertical: 'middle',
          wrapText: true,
        },
        border: {
          bottom: {
            style: 'thick',
            color: { argb: 'FFFFFF' },
          },
        },
      };
    });

    const numColumns = properties.length;
    const rows: Row[] = [];
    for (let i = 0; i < numColumns; i++) {
      const row = worksheet.addRow([]);
      rows.push(row);
    }

    //Description Table
    rowHeaders.forEach((header, index) => {
      let headerTranslate = this.translateService.instant(header);
      rows[index].getCell(3).value = headerTranslate;
      if (index % 2 === 0) {
        rows[index].getCell(3).style = {
          alignment: { vertical: 'middle', horizontal: 'center', wrapText: true },
          font: { name: 'Arial', size: 8 },
          fill: {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '969696' },
            bgColor: { argb: '969696' },
          },
        };
      } else {
        rows[index].getCell(3).style = {
          alignment: { vertical: 'middle', horizontal: 'center', wrapText: true },
          font: { name: 'Arial', size: 8 },
        };
      }
    });

    const exceptionRow = [grayValuePosition];
    //BODY
    tableBody?.forEach((item, index) => {
      const start = 6 * (index + 1);
      for (let i = start, j = 0; i <= start + 2; i += 2, j++) {
        if (j === 0) {
          for (let index = 0; index < numColumns; index++) {
            if (exceptionRow.find((exception) => exception === index)) rows[index].getCell(i).value = item.strTinT;
            else rows[index].getCell(i).value = '';

            rows[index].getCell(i).style = {
              font: { name: 'Arial', size: 7, underline: false },
              border: {
                top: {
                  style: 'thick',
                  color: { argb: 'FFFFFF' },
                },
                bottom: {
                  style: 'thick',
                  color: { argb: 'FFFFFF' },
                },
              },
            };
          }
        } else {
          for (let index = 0; index < numColumns; index++) {
            rows[index].getCell(i).value = item[properties[index]];
            rows[index].getCell(i).style = {
              //   alignment: { vertical: 'middle', horizontal: 'center' },
              font: { name: 'Arial', size: 7, underline: false },
              border: {
                top: {
                  style: 'thick',
                  color: { argb: 'FFFFFF' },
                },
                bottom: {
                  style: 'thick',
                  color: { argb: 'FFFFFF' },
                },
              },
            };
          }
        }
      }
    });

    this.footerExcelTariffSheet(description, contact, worksheet, tableHeaders.length * 5 + tableHeaders.length + 3);

    //SET WIDTH COLUMNS
    const descriptionWidth = 15;
    const contentWidth = 5.75;
    const separatorWidth = 1;
    const colsWidth: number = (tableHeaders.length + 1) * 5 + tableHeaders.length;

    worksheet.getColumn(2).width = separatorWidth;
    worksheet.getColumn(3).width = descriptionWidth;
    worksheet.getColumn(4).width = separatorWidth;

    for (let i = 5, counter = 0; i < colsWidth; i++) {
      let column = worksheet.getColumn(i);

      if (column.width !== contentWidth && column.width !== separatorWidth) {
        column.width = i % 2 === 0 ? contentWidth : separatorWidth;
      }

      if (i !== 5 && i % 5 === 0) {
        i += counter;
        column = worksheet.getColumn(i);
        column.width = separatorWidth;
        i -= counter;
        counter++;
      }
    }

    worksheet.eachRow({ includeEmpty: true }, (row, rowIndex) => {
      for (let cellIndex = 1; cellIndex <= colsWidth; cellIndex++) {
        const cell = worksheet.getCell(row.number, cellIndex);
        const cellProps = Object.keys(cell.style);
        if (cellProps?.length === 0 || !cellProps.includes('fill')) {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFFFFF' },
            bgColor: { argb: 'FFFFFF' },
          };
        }
      }
    });

    this.generateExcel(fileName, workbook);
  }

  public checkNumbersFormat(excelData: any) {
    let data = excelData;
    //Esta expresion comprueba que un valor contiene varios numeros delante de un punto, despues 3 numeros y luego una coma seguido de 2 numeros.
    let regex: RegExp = new RegExp(REGEX_FORMAT_NUMBER);
    let regexWithoutDot: RegExp = new RegExp(REGEX_WITHOUT_DOT);
    let expresion_any_letter = REGEX_ANY_LETTER;
    let regular_expresion_date = REGEX_VALID_DATE;
    //Con esta expresión se puede validar todos los datos que sean numericos y tengan una coma de manera opcional.
    let regexNumbersWithoutHundreds: RegExp = new RegExp(REGEX_NUMBER_WITHOUT_HUNDREDS);

    let check = regex.test(data as string);
    let checkWithoutDot = regexWithoutDot.test(data as string);

    let checkNumbersWithoutHundreds = regexNumbersWithoutHundreds.test(data as string);
    //Comrpobar que es menor que 15 digitos para que no cambie el numero de solicitud
    if (typeof data === 'string') {
      if (!expresion_any_letter.test(data) && !regular_expresion_date.test(data) && data.length < 15) {
        if (check || checkNumbersWithoutHundreds || checkWithoutDot) {
          data = parseFloat(this.removeFormat.transform(data));
        }
      }
    }

    return data;
  }

  public generateNewData(excelData?: any) {
    let data = excelData?.map((element: any) => {
      return JSON.parse(JSON.stringify(element));
    });

    for (let i = 0; i < data.length; i++) {
      let keys = Object.keys(data[i]);
      for (let j = 0; j < keys.length; j++) {
        data[i][keys[j]] = this.checkNumbersFormat(data[i][keys[j]]);
      }
    }

    return data;
  }
  exportExcelActivityMonthly = (excelData: any, division: number) => {
    //Title, Header & Data
    const headers: string[] = excelData.headers;
    const data: MonthlyResult[] = excelData.data;
    const title =
      this.translateService.instant('monthlyReport.filename.excel') + moment().locale('es').format('DDMMYYYY');

    //Create a workbook with a worksheet
    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet('Page 1', {
      pageSetup: {
        margins: {
          top: 0.1,
          left: 0.1,
          bottom: 0.1,
          right: 0.1,
          header: 0.1,
          footer: 0.1,
        },
      },
    });

    if (division === UserDivisions.AUTOS) {
      worksheet.pageSetup.scale = 85;
    }

    this.headerActivityMonthly(workbook, worksheet, headers, division);

    data.forEach((item: MonthlyResult, i: number) => {
      //Table
      const establishmentRow = worksheet.addRow([item.agentPk]);
      const establishmentCell = establishmentRow.getCell(1).$col$row.split('$');
      let row = establishmentCell[establishmentCell.length - 1];
      worksheet.mergeCells('A' + row, 'F' + row);
      worksheet.getCell('A' + row).font = {
        name: 'Arial Black',
        size: 9,
      };

      const dataItems: any[] =
        UserDivisions.AUTOS === division
          ? item.statusAuto?.map((item) => [
              item.state,
              item.p20,
              item.p15,
              item.p10,
              item.p30,
              item.p40,
              item.total,
              this.formatNumbersToThousands(item.financed),
              this.formatNumbersToThousands(item.incAgent),
              this.formatNumbersToThousands(item.incSeller),
              item.losses,
              item.ppb,
              item.ppt,
              this.formatNumbersToThousands(item.incProtections),
            ])
          : item.statusConsumption?.map((item) => [
              item.state,
              item.p10,
              item.p30,
              item.total,
              this.formatNumbersToThousands(item.financed),
              item.ppt,
            ]);

      dataItems?.forEach((dataItem, index) => {
        const rowData = worksheet.addRow(dataItem);
        rowData.eachCell((cell: Cell, number: any) => {
          cell.style = {
            font: {
              name: 'Arial',
              size: 9,
            },
            border: {
              right: { style: 'thin' },
            },
          };
          if (index === 0) {
            cell.border = {
              top: { style: 'thick' },
              right: { style: 'thin' },
            };
          }
        });
      });
    });

    worksheet.columns.forEach(function (column, i) {
      if (division === UserDivisions.CONSUMPTION) {
        column.width = i === 0 ? 40 : i === 4 ? 25 : 10;
      } else {
        column.width = i === 0 ? 35 : i === 7 || i === 8 || i === 9 || i === 13 ? 12 : i === 6 ? 8 : 4;
      }
    });

    this.generateExcel(title, workbook);
  };

  private formatNumbersToThousands(value: number): string {
    return new Intl.NumberFormat(LOCALE_DE, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  }
  private headerActivityMonthly = (workbook: Workbook, worksheet: Worksheet, headers: string[], division: number) => {
    //Add Row and formatting
    division === UserDivisions.CONSUMPTION ? worksheet.mergeCells('B1', 'F5') : worksheet.mergeCells('B1', 'N5');
    const titleRow = worksheet.getCell('B1');
    titleRow.value = this.translateService.instant('monthlyReport.excel.title');
    titleRow.style = {
      font: {
        name: 'Calibri',
        size: 18,
        bold: true,
        color: { argb: '969696' },
      },
      alignment: { vertical: 'middle', horizontal: 'center' },
    };

    worksheet.mergeCells('A6:D6');
    const titleScreen = worksheet.getCell('A6');
    titleScreen.value = this.translateService.instant('monthlyReport.excel.subtitle');
    titleScreen.style = {
      font: {
        name: 'Calibri',
        size: 16,
        bold: true,
        color: { argb: '969696' },
      },
      alignment: { vertical: 'middle', horizontal: 'left' },
    };

    division === UserDivisions.CONSUMPTION ? worksheet.mergeCells('E6:F6') : worksheet.mergeCells('E6:N6');
    const date: string = this.datePipe.transform(new Date(), 'dd-MM-yyyy HH:mm:ss');
    const dateCell = worksheet.getCell('E6');
    dateCell.value = date;
    dateCell.style = {
      font: { name: 'Calibri' },
      alignment: { vertical: 'middle', horizontal: 'right' },
    };

    //Add Image
    const myLogoImage = workbook.addImage({
      base64: logo,
      extension: 'png',
    });
    worksheet.mergeCells('A1:A5');
    worksheet.addImage(myLogoImage, 'A1:A5');

    //Adding Header Row
    let headerRow = worksheet.addRow(headers);
    headerRow.eachCell((cell, number) => {
      cell.style = {
        border: {
          right: { style: 'thin', color: { argb: 'FFFFFF' } },
        },
        fill: {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '969696' },
          bgColor: { argb: '' },
        },
        font: {
          name: 'Arial',
          bold: true,
          color: { argb: 'FFFFFF' },
          size: 9,
        },
      };
    });
  };

  headerExcelPenaltyDetail(
    title: string,
    header: string[],
    workbook: Workbook,
    worksheet: Worksheet,
    excelData: excelDataPenalty
  ) {
    let titleRow;
    if (title.length < 28) {
      worksheet.mergeCells('H1', 'K5');
      titleRow = worksheet.getCell('H1');
    } else {
      worksheet.mergeCells('G1', 'K5');
      titleRow = worksheet.getCell('G1');
    }

    titleRow.value = title;
    titleRow.font = {
      name: 'Calibri',
      size: 30,
      bold: true,
      color: { argb: '1E90FF' },
    };
    titleRow.alignment = { vertical: 'middle', horizontal: 'center' };

    //Date and page
    worksheet.getCell('I6').value = this.translateService.instant('penalty.excel.date') + ':';
    worksheet.getCell('I6').style = { alignment: { vertical: 'middle', horizontal: 'right' }, font: { bold: true } };
    worksheet.mergeCells('J6:K6');
    let d = new Date();
    let month = d.getMonth() + 1;
    let date = d.getDate() + '/' + (month < 10 ? '0' + month : '' + month) + '/' + d.getFullYear();
    let dateCell = worksheet.getCell('J6');
    dateCell.value = date;
    dateCell.style = { alignment: { vertical: 'middle', horizontal: 'left' } };

    worksheet.getCell('I7').value = this.translateService.instant('penalty.excel.page');
    worksheet.getCell('I7').style = { alignment: { vertical: 'middle', horizontal: 'left' }, font: { bold: true } };
    worksheet.getCell('J7').value = worksheet.id;
    worksheet.getCell('J7').alignment = { horizontal: 'left', vertical: 'middle' };

    //Add Image
    let myLogoImage = workbook.addImage({
      base64: logo,
      extension: 'png',
    });
    worksheet.mergeCells('A1:C7');
    worksheet.addImage(myLogoImage, 'A1:C7');

    if (worksheet.id === 1) {
      //Add search criteria
      worksheet.mergeCells('A13:C13');
      worksheet.getCell('A13').value = 'De ' + excelData.initialDate + ' a ' + excelData.finalDate;
    }

    //Adding Header Row
    worksheet.addRow([]);
    worksheet.mergeCells('A15:E15');
    worksheet.getCell('A15').value = this.translateService.instant('penalty.detail.title');
    worksheet.getCell('A15').style = {
      alignment: { horizontal: 'center' },
      font: {
        name: 'Calibri',
        size: 12,
        bold: true,
        underline: 'single',
        color: { argb: '828282' },
      },
    };
    let headerRow = worksheet.addRow(header);
    headerRow.eachCell((cell, number) => {
      cell.style = {
        alignment: { horizontal: 'center', vertical: 'middle' },
        fill: {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '969696' },
          bgColor: { argb: '' },
        },
        font: {
          bold: true,
          color: { argb: 'FFFFFF' },
          size: 12,
        },
      };
    });
  }

  exporExcelPenaltyDetail(excelData: excelDataPenalty) {
    const title = this.translateService.instant('excel.dashboard.title');
    const date = moment().locale('es');
    const filename = this.translateService.instant('penalty.detail.title.dashboard') + date.format('DDMMYYYY');

    let header = excelData.data.headers as string[];
    const data: any = excelData.data.data.map((element: any) => {
      return JSON.parse(JSON.stringify(element));
    });

    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet(this.translateService.instant('penalty.excel.sheet') + ' 1');

    let dataExcelOrder;
    for (let i = 0; i < data.length; i++) {
      if (i === 0) {
        this.headerExcelPenaltyDetail(title, header, workbook, worksheet, excelData);
        worksheet.columns.forEach(function (column, i) {
          column.width =
            i === 0 || i === 8 || i === 11 || i === 1
              ? 19
              : i === 6
              ? 22
              : i === 7
              ? 25
              : i === 2 || i === 3 || i == 4 || i === 5 || i === 9 || i === 10 || i === 12 || i === 13
              ? 17
              : i === 11 || i === 14 || i === 15 || i === 16
              ? 13
              : 0;
          column.alignment = i === 2 ? { wrapText: true } : {};
        });
      }
      dataExcelOrder = JSON.stringify(data[i], [
        'codBeneficiary',
        'beneficiary',
        'contractId',
        'holderName',
        'productDesc',
        'autDate',
        'amountPenalty',
        'reason',
      ]);

      const objectDataExcel = JSON.parse(dataExcelOrder);
      let dataRow = worksheet.addRow(Object.values(objectDataExcel));
      dataRow.eachCell((cell, number) => {
        cell.style = {
          alignment: { vertical: 'middle', horizontal: 'center', wrapText: true },
        };
      });
    }

    this.generateExcel(filename, workbook);
  }
}
